export default {
  default: () => import("/home/forge/amosweb.de/releases/20250708085539/registration/layouts/default.vue").then(m => m.default || m),
  "event-overview": () => import("/home/forge/amosweb.de/releases/20250708085539/registration/layouts/eventOverview.vue").then(m => m.default || m),
  "event-registration": () => import("/home/forge/amosweb.de/releases/20250708085539/registration/layouts/eventRegistration.vue").then(m => m.default || m)
}